<script setup lang="ts">
withDefaults(defineProps<{ as?: string; padded?: boolean }>(), { as: 'div' })
</script>

<template>
  <component :is="as" class="ui-card" :class="{ 'ui-card--padded': padded }"><slot /></component>
</template>

<style scoped>
.ui-card {
  background: var(--surface-card);
  border: var(--hairline) solid var(--separator);
  border-radius: var(--radius-list);
}
.ui-card--padded {
  padding: 24px;
}
</style>
